import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Navigate, Outlet, RouterProvider, createBrowserRouter, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@frontend/auth/AuthProvider";
import { AppShell } from "@frontend/components/AppShell";
import { LoadingState } from "@frontend/components/ui";
import { CollectorPage } from "@frontend/pages/CollectorPage";
import { CamerasPage } from "@frontend/pages/CamerasPage";
import { CollectorsPage } from "@frontend/pages/CollectorsPage";
import { FramesPage } from "@frontend/pages/FramesPage";
import { LoginPage } from "@frontend/pages/LoginPage";
import { OverviewPage } from "@frontend/pages/OverviewPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 15_000 },
    mutations: { retry: false },
  },
});

const router = createBrowserRouter([
  {
    element: <AuthBoundary />,
    children: [
      { path: "/login", element: <LoginPage /> },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <AppShell />,
            children: [
              { index: true, element: <OverviewPage /> },
              { path: "cameras", element: <CamerasPage /> },
              { path: "collectors", element: <CollectorsPage /> },
              { path: "collectors/:collectorId", element: <CollectorPage /> },
              { path: "frames", element: <FramesPage /> },
            ],
          },
        ],
      },
      { path: "*", element: <Navigate replace to="/" /> },
    ],
  },
]);

export function App() {
  return <QueryClientProvider client={queryClient}><AuthProvider><RouterProvider router={router} /></AuthProvider></QueryClientProvider>;
}

function AuthBoundary() {
  const { state } = useAuth();
  if (state === "loading") {
    return <div className="bootstrap-loading"><LoadingState label="Abrindo o console" /></div>;
  }
  return <Outlet />;
}

function ProtectedRoute() {
  const { state } = useAuth();
  const location = useLocation();
  if (state !== "authenticated") {
    return <Navigate replace state={{ from: location.pathname }} to="/login" />;
  }
  return <Outlet />;
}
